import type { MouseEventHandler, VFC } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  button: {
    color: '#541414', // テキストの色
    border: '1px solid #541414', // 枠線の色
    fontSize: 16,
    height: 48,
    marginBottom: 16,
    width: 256,
    backgroundColor: '#5414141F', // 背景色をかなり薄くした#541414
    '&:hover': {
      backgroundColor: '#5414141F', // ホバー時の背景色を少し濃く
    },
  },
});

type Props = {
  label: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export const PrimaryOutlineButton: VFC<Props> = (props: any) => {
  const { label, onClick } = props;
  const classes = useStyles();

  return (
    <Button
      className={classes.button}
      variant='outlined'
      onClick={() => onClick()}
    >
      {label}
    </Button>
  );
};
